module.exports = __webpack_public_path__ + "media/tape-nav/commerce-dashboard-icon-5d3ad4c7.svg";